<template>
    <ModalBase
        name="addMonedero"
        :title="'Nuevo saldo para ' + abonado.name + ' ' + abonado.surnames"
        @close="close(false)"
    >
        <ValidationObserver tag="form" ref="observer" class="tw:flex tw:flex-col tw:gap-4" @submit.prevent="submit">
            <BaseInputText label="Descripción" name="descripcion" rules="required" :value="data.descripcion" @input="data.descripcion = $event" />
            <BaseInputNumber name="importe" rules="required" :step="0.01" :decimals-only="true" decimal-rule="decimal_monedero" placeholder="Importe (ej: 10.50, -5.00)" :value="data.importe" @input="data.importe = $event" />
            <Button type="submit" :disabled="loading">añadir</Button>
        </ValidationObserver>
    </ModalBase>
</template>


<script setup>
    import { reactive, ref } from 'vue'
    import store from '@/store'
    import { useToast } from '@/composables/common/useToast'
    import { config } from '@/config'
    import ModalBase from '@/modules/admin/ui/ModalBase'
    import BaseInputText from '@/modules/admin/ui/BaseInputText'
    import Button from '@/modules/admin/ui/Button.vue'
    import BaseInputNumber from '@/modules/admin/ui/BaseInputNumber.vue'

    const props = defineProps({
        abonado: Object
    })

    const emit = defineEmits(['close'])
    const toast = useToast()

    const data = reactive({
        descripcion: '',
        importe: ''
    })
    const loading = ref(false)
    const observer = ref(null)

    const close = (actualizar = false) => {
        data.descripcion = ''
        data.importe = ''
        emit('close', 'addMonedero', actualizar)
    }

    const submit = async() => {
        const isValid = await observer.value.validate()
        if (isValid) {
            data.abonado_id = props.abonado.id
            loading.value = true

            store.dispatch(config.getVuexAlias('back.abonados.monedero.add'), data)
                .then(res => {
                    const successMessage = res.data?.message || 'Dinero agregado al monedero'
                    toast.success(successMessage)
                    close(true)
                })
                .catch(err => {
                    const errorMessage = err.response?.data?.message || 'Error al añadir monedero'
                    toast.error(errorMessage)
                    close(false)
                })
                .finally(() => {
                    loading.value = false
                })
        }
    }
</script>
